import type { Product } from '../types';

/**
 * Simple function to enforce type checks (e.g. ['jera'].includes(product) is valid code, but likely a bug)
 */
export function isProductOneOf(product: Product, possibleMatches: Product[]): boolean {
	return possibleMatches.includes(product);
}
